import { useTranslation } from "react-i18next";
import { MenuNav } from "./MenuNav";
import SettingsStore from "@/stores/SettingsStore";
import { Bot } from "lucide-react";

export function PageHeader() {
  const { t } = useTranslation();
  const brandingLogoUrl = SettingsStore(state => state.brandingLogoUrl);
  const brandingTitle = SettingsStore(state => state.brandingTitle);

  return (
    <div className={"flex"}>
      <div
        className="p-2 min-w-56 flex items-center justify-center bg-muted"
      >
        <a href="/">
          {brandingLogoUrl ? (
            <img alt="Logo" width={150} src={brandingLogoUrl} />
          ) : (
            <Bot className="w-10 h-10 text-muted-foreground" />
          )}
        </a>
      </div>
      <div className={"p-4 w-full flex justify-between items-center smScreen:flex-row"}>
        <div className="flex flex-col">
          <h1 className="text-2xl text-gray-700 font-bold">{brandingTitle || t("settings.settingsTitle")}</h1>
        </div>
        <MenuNav />
      </div>
    </div>
  )
}